import User from '@/ship/Models/User';
import ITransformedValue from '../../Values/ITransformedValue';

export interface OptionSelector {
    id: number;
    name: string;
}

export interface FiltersLaborProtection {
    cities: OptionSelector[];
    projects: OptionSelector[];
}

export interface ILaborProtectionFilter {
    cityId?: number | null;
    projectId?: number | null;
    authorId?: number | null;
    generalContractorId?: number | null;
    date?: string | string[];
}

export interface CreateChecklistFormData {
    project: OptionSelector | null;
    general: string;
    author: User | null;
    inspectionDate: string;
    answers: number[];
}

export enum LaborProtectionTabEnum {
    rating = 1, // Рейтинг по ОТ и ТБ
    checklists, // Чек-листы по ОТ и ТБ
    accidents, // Несчастные случаи
}

export interface CreateLaborProtectionChecklist {
    project_id: number;
    date: string;
    answers: number[];
    checklist_questions_set_id: number;
}

export interface AnswerType {
    score: number;
    text: string;
}

export interface QuestionType {
    question: string;
    answers: AnswerType[];
}

export interface IncludeQuestionsList {
    id: number;
    data: QuestionType[];
}

export interface IncludeLaborProtectionChecklist {
    answers: number[];
    author: ITransformedValue<User> | null;
    authorId: number | null;
    checklistQuestionsSetId: number;
    createdAt: string;
    date: string;
    generalContractorId: number | null;
    id: number;
    projectId: number;
    result: number;
}

export interface IQuestionsList {
    title: string;
    options: string[];
}

export interface IncludeLaborProtectionAccident {
    accidentList: { name: string; description: string }[];
    author: ITransformedValue<User> | null;
    authorId: number | null;
    createdAt: string;
    date: string;
    generalContractorId: number | null;
    id: number;
    projectId: number;
    subcontractorId: number;
    text: string;
    time: string;
}

export interface CreateLaborProtectionAccident {
    project_id: number;
    general_contractor_id?: number;
    subcontractor_id?: number;
    author_id?: number;
    date: string;
    text: string;
    time: string;
    accident_list: { name: string; description: string }[];
}

export interface CreateAccidentFormData {
    project: OptionSelector | null;
    subcontractor: OptionSelector | null;
    author: OptionSelector | null;
    accidentDate: string;
    accidentTime: string;
    description: string;
    accidentList: { name: string; description: string }[];
}

export interface ILaborProtectionRatingItem {
    accidentsCount: number;
    accidentsDate: string | null;
    checklistResult: number;
    cityName: string;
    daysFromLastAccident: number | null;
    number: number;
    projectId: number;
    projectName: string;
}
